/* Default user interaction timeout for triggering idle session timeout in seconds to match kiosk*/
export const BaseIdleSessionTimeout = 30;
